import $ from "../jquery_global";

// Supplier Client Name Mappings — popovers, searchable selects, group-scoped hotels.

var scmHotelsByGroup = null;

function supplierClientNameMappingsRoot($context) {
  if ($context && $context.length) return $context;
  return $('#supplier-client-name-mappings');
}

function loadScmHotelsByGroup() {
  var node = document.getElementById('scm-hotels-by-group');
  if (!node) return {};

  try {
    return JSON.parse(node.textContent);
  } catch (_e) {
    return {};
  }
}

function scmSelect2Options($el) {
  return {
    width: '100%',
    placeholder: $el.data('placeholder') || 'Select...',
    allowClear: true,
    dropdownParent: $(document.body)
  };
}

function initScmSelect2($el) {
  if (!$el.length) return;

  if ($el.data('select2')) {
    $el.select2('destroy');
  }

  $el.select2(scmSelect2Options($el));
}

function rebuildScmHotelOptions($groupSelect, $hotelSelect) {
  var groupId = $groupSelect.val();
  var previousHotelId = $hotelSelect.val();
  var hotels = (scmHotelsByGroup && scmHotelsByGroup[groupId]) || [];
  var validHotelIds = hotels.map(function (h) { return String(h.id); });

  if ($hotelSelect.data('select2')) {
    $hotelSelect.select2('destroy');
  }

  $hotelSelect.empty();
  $hotelSelect.append(new Option('Select hotel', '', false, false));

  hotels.forEach(function (hotel) {
    var selected = String(hotel.id) === String(previousHotelId);
    $hotelSelect.append(new Option(hotel.name, hotel.id, false, selected));
  });

  if (previousHotelId && validHotelIds.indexOf(String(previousHotelId)) === -1) {
    $hotelSelect.val('');
  }

  initScmSelect2($hotelSelect);
}

function initSupplierClientNameMappingRow($row) {
  var $groupSelect = $row.find('.scm-group-select');
  var $hotelSelect = $row.find('.scm-hotel-select');

  if (!$groupSelect.length || !$hotelSelect.length) return;

  initScmSelect2($groupSelect);
  rebuildScmHotelOptions($groupSelect, $hotelSelect);
  updateScmConfirmButton($row);

  $groupSelect.off('change.scm').on('change.scm', function () {
    rebuildScmHotelOptions($groupSelect, $hotelSelect);
    updateScmConfirmButton($row);
  });

  // Hotel select is rebuilt on group change, so bind via the row (delegated).
  $row.off('change.scmHotel').on('change.scmHotel', '.scm-hotel-select', function () {
    updateScmConfirmButton($row);
  });
}

// Confirm requires both a group and a hotel.
function updateScmConfirmButton($row) {
  var $confirm = $row.find('.scm-confirm-btn');
  if (!$confirm.length) return;

  var ready = !!$row.find('.scm-group-select').val() && !!$row.find('.scm-hotel-select').val();
  $confirm.prop('disabled', !ready);
  $confirm.toggleClass('disabled', !ready);
  $confirm.attr('title', ready ? 'Confirm' : 'Select a group and hotel to confirm');
  if ($confirm.data('bs.tooltip') || $confirm.attr('data-original-title') !== undefined) {
    $confirm.attr('data-original-title', $confirm.attr('title'));
  }
}

function initSupplierClientNameMappingSelects($context) {
  var $root = supplierClientNameMappingsRoot($context);
  if (!$root.length) return;

  scmHotelsByGroup = loadScmHotelsByGroup();

  $root.find('tbody tr').each(function () {
    initSupplierClientNameMappingRow($(this));
  });
}

function refreshSupplierClientNameMappingPopovers($context) {
  var $root = supplierClientNameMappingsRoot($context);
  if (!$root.length) return;

  $root.find('[data-toggle="popover"]').each(function () {
    var $el = $(this);
    if ($el.data('bs.popover')) $el.popover('dispose');
    $el.popover({
      container: 'body',
      trigger: 'hover',
      delay: { show: 100, hide: 150 }
    });
  });
}

function refreshSupplierClientNameMappingsPage($context) {
  refreshSupplierClientNameMappingPopovers($context);
  initSupplierClientNameMappingSelects($context);
}

$(document).on('turbo:load ajax:success', function () {
  refreshSupplierClientNameMappingsPage();
});

$(document).ajaxSuccess(function () {
  if ($('#supplier-client-name-mappings').length) {
    refreshSupplierClientNameMappingsPage();
  }
});

window.refreshSupplierClientNameMappingPopovers = refreshSupplierClientNameMappingPopovers;
window.refreshSupplierClientNameMappingsPage = refreshSupplierClientNameMappingsPage;
